<template>
  <div class="container">
    <div class="alert alert-info" role="alert">
      <fa-icon :icon="['far', 'shopping-cart']" /> {{ $t("cart.empty") }}
    </div>
    <div class="btn-row row justify-content-between">
      <div class="col">
        <a
          @click="onContinueClick"
          :href="continue_shopping_url"
          class="btn btn-deafult"
        >
          <fa-icon :icon="['far', 'arrow-left']" />
          {{ $t("cart.continueshopping") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  methods: {
    onContinueClick: function (event) {
      if (this.isIframe) {
        event.preventDefault();
        window.postMessage("triggerCloseDPDLightbox", "*");
      }
    },
  },
  computed: {
    continue_shopping_url: get("continue_shopping_url"),
  },
};
</script>
